import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ShoppingBagIcon } from 'lucide-react';
import { Pkg } from '../data/content';
type Props = {
  selectedPackage: Pkg;
  onChangePackage: () => void;
  onBuyNow: () => void;
};
export function StickyPurchaseBar({
  selectedPackage,
  onChangePackage,
  onBuyNow
}: Props) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const updateVisibility = () => setVisible(window.scrollY > Math.max(window.innerHeight * 0.7, 460));
    updateVisibility();
    window.addEventListener('scroll', updateVisibility, {
      passive: true
    });
    window.addEventListener('resize', updateVisibility);
    return () => {
      window.removeEventListener('scroll', updateVisibility);
      window.removeEventListener('resize', updateVisibility);
    };
  }, []);
  return <AnimatePresence data-id="element-292" data-mp="96nfgs7lww9d">
      {visible && <motion.aside initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.28,
      ease: [0.22, 1, 0.36, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-forest/15 bg-ivory/95 px-4 py-3 shadow-[0_-14px_38px_rgba(6,46,36,0.12)] backdrop-blur-md md:px-8" aria-label="Quick purchase options" data-id="element-293" data-mp="e6j9bymlb7b7">
          <div className="mx-auto flex max-w-5xl flex-wrap items-center justify-center gap-2 sm:flex-nowrap sm:justify-between sm:gap-4" data-id="element-294" data-mp="8e4ye5sue897">
            <button onClick={onChangePackage} className="flex min-w-0 items-center gap-2 rounded-full border border-forest/15 bg-white px-4 py-2.5 text-left text-forest transition-colors hover:border-forest/40" aria-label="Change selected package" data-id="element-295" data-mp="3vje3pv359f3b">
              <span className="hidden text-xs font-semibold uppercase tracking-wide text-sage sm:inline" data-id="element-296" data-mp="1ot6f81vdxem3">Selected</span>
              <span className="truncate text-sm font-semibold" data-id="element-297" data-mp="1jumv870cqcwd">{selectedPackage.name}</span>
              <span className="text-sm text-forest/60" data-id="element-298" data-mp="3e9ikko9lrk3h">{selectedPackage.price}</span>
              <ChevronDownIcon className="h-4 w-4 shrink-0" data-id="element-299" data-mp="3j10kd8zw3emv" />
            </button>
            <button onClick={onBuyNow} className="flex flex-1 items-center justify-center gap-2 rounded-full bg-forest px-5 py-3 text-sm font-semibold text-ivory transition-colors hover:bg-forest-deep sm:max-w-xs" data-id="element-300" data-mp="34bmb00wbcx7h">
              <ShoppingBagIcon className="h-4 w-4" data-id="element-301" data-mp="vf3fjas2ftf" /> Buy Now
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}